module.exports = __webpack_public_path__ + "media/audio48.4b8c18de.mp3";